module.exports = __webpack_public_path__ + "img/paladin.18d069d0.jpg";